import * as React from 'react';

import ListingMap from '../../utility/ListingMap';
import styles from '../../../styles/sass/pages/Search.module.scss';

export interface Props {
  allowDrawing?: boolean;
  initialMapLoad?: boolean;
  favorites: any[];
  feed: any[];
  feedSearch: any;
  loadMapFeed: Function;
  mapHeight: number;
  placeBoundaries?: any;
  toggleCityBoundary: Function;
  routerLocation: string | undefined;
}

export interface State {
  mapReady: boolean;
}

class FeedMap extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      mapReady: false,
    };
  }

  componentDidMount() {
    this.initMap();
  }

  setCenter = () => {
    this.setState({
      mapReady: true,
    });
  };

  initMap = () => {
    this.setCenter();
  };

  render() {
    const latLong =
      this.props.routerLocation &&
      this.props.routerLocation.split(',').length === 2
        ? this.props.routerLocation.split(',')
        : this.props.feedSearch.location.split(',');
    const mapLatCenter = parseFloat(latLong[0]);
    const mapLngCenter = parseFloat(latLong[1]);
    return this.state.mapReady ? (
      <div
        className={`${styles.listingMapContainer} listing-map-container`}
        id="listing-map-container"
      >
        <div
          className={`${styles.mapInnerContainer} map-inner-container`}
          style={{ height: this.props.mapHeight }}
        >
          <ListingMap
            allowDrawing={this.props.allowDrawing}
            favorites={this.props.favorites}
            feed={this.props.feed}
            initialMapLoad={this.props.initialMapLoad}
            isMarkerShown
            latitude={mapLatCenter}
            loadMapFeed={this.props.loadMapFeed}
            longitude={mapLngCenter}
            placeBoundaries={this.props.placeBoundaries}
            toggleCityBoundary={this.props.toggleCityBoundary}
            zoom={this.props.feedSearch.zoom || 13}
          />
        </div>
      </div>
    ) : null;
  }
}

export default FeedMap;
